export { default as restApiClientConfiguration } from './rest-api-client/configuration';
export {
	debouncedConfigureRestApiClient as configureRestApiClient,
	getTenantId,
} from './subscription-rest-api-configuration';

export {
	// contentProperties.js
	updateContentProperty,
	// content.js
	editPageMetadata,
	editorPage,
	publishEditorPage,
	syncEditorDraft,
	publishEditorPageFromTemplate,
	createPage,
	draftMetadata,
	cancelScheduledPublish,
	// editor.js
	getPluginCodeLanguages,
	getWikiConfluenceToXhtml,
	getWikiMarkdownToXhtml,
	// labels.js
	suggest,
	// spaces.js
	space,
	// feature-discovery.js
	markDiscovered,
} from '@confluence-classic/confluence-rest-api';
